import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UIKitBaseComponent } from '@macs-frontend/features';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-radio-button',
  templateUrl: './radio-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonComponent extends UIKitBaseComponent {
  // @ts-expect-error
  @Input() label: string;
}
